import AmexShopSmallHeader from './AmexShopSmallHeader';

export default AmexShopSmallHeader;
